import React, { useRef } from "react";
import styled from "styled-components";
import { OverlayPanel } from "primereact/overlaypanel";
import moreIcon from "../../assets/icons/more.png";

const Options = styled.div`
  font-family: Verizon-NHG-eTX, Helvetica, Ariel, sans-serif;
  font-size: 12px;
  color: #000;
  margin-top: ${(props) => (props.marginTop ? props.marginTop : "0.4rem")};
  cursor: pointer;
`;

const ThreeDotsTemplate = ({ caseDetails, handleViewDetails }) => {
  const moreOperations = useRef(null);
  const buttonRef = useRef(null);
  const handleActions = (action) => {
    moreOperations.current.hide();
    switch (action) {
      case "View details":
        handleViewDetails(caseDetails);
        break;
    }
  };
  const showOverlay = () => {
    let overlay = document.getElementById("overlay_panel");
    overlay.removeAttribute("hidden");
    document.getElementById("listItem1").focus();
  };

  return (
    <>
      <OverlayPanel ref={moreOperations} id="overlay_panel" onShow={showOverlay} aria-modal="true">
        <div role="listbox">
          <Options
            role="option"
            tabIndex="0"
            aria-label="View details event"
            onClick={() => handleActions("View details")}
            id="listItem1"
            marginTop="0.2rem"
            onKeyDown={(e) => {
              if (e.key === "ArrowDown") {
                document.getElementById("listItem1").focus();
              } else if (e.key === "Enter") {
                handleActions("View details");
              }
            }}
          >
            View details
          </Options>
        </div>
      </OverlayPanel>
      {caseDetails?.status?.toLowerCase() === "scheduled" ? (
        <img
          ref={buttonRef}
          style={{ width: "15px" }}
          alt="more-options-button"
          aria-label="more-options-button"
          src={moreIcon}
          onClick={(e) => moreOperations.current.toggle(e)}
          tabIndex="0"
          role="button"
          aria-controls="overlay_panel"
          aria-expanded={false}
          aria-haspopup="listbox"
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              moreOperations.current.toggle(e);
            }
          }}
          className="more_option"
        />
      ) : (
        <></>
      )}
    </>
  );
};
export default React.memo(ThreeDotsTemplate);
